import React, { useEffect } from 'react';
import { HomeNavigation } from './home/HomeNavigation';
import { HomeHero } from './home/HomeHero';
import { HomeProgramsSection } from './home/HomeProgramsSection';
import { HomeLocalAuthoritySection } from './home/HomeLocalAuthoritySection';
import { HomeBenefitsSection } from './home/HomeBenefitsSection';
import { HomeFacilitySection } from './home/HomeFacilitySection';
import { HomeCTASection } from './home/HomeCTASection';
import { HomeFooter } from './home/HomeFooter';
export function HomePage() {
  useEffect(() => {
    document.title = "Walker's Martial Arts | Taekwondo & Kickboxing | Bloomington, Illinois";
  }, []);
  return <div className="bg-black" data-id="element-1255">
      <HomeNavigation data-id="element-1256" />
      <HomeHero data-id="element-1257" />
      <HomeProgramsSection data-id="element-1258" />
      <HomeLocalAuthoritySection data-id="element-1259" />
      <HomeBenefitsSection data-id="element-1260" />
      <HomeFacilitySection data-id="element-1261" />
      <HomeCTASection data-id="element-1262" />
      <HomeFooter data-id="element-1263" />
    </div>;
}